import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService, StorageService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class LoginGuard implements CanActivate {

    memoryStorage;
    guest;

    constructor(private router: Router, private storageService: StorageService,
                private baseService: BaseService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const uId = this.storageService.getLocalStore('u_id');
        if (!uId) {
            return true;
        } else {
            this.router.navigateByUrl('/home');
            return false;
        }
    }
}
